// src/pages/TermsAndConditions.js
import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../assets/css/TermsAndConditions.css";

// Section imports
import Section1Introduction from "../components/termsSections/Section1Introduction";
import Section2Acceptance from "../components/termsSections/Section2Acceptance";
import Section3Definition from "../components/termsSections/Section3Definition";
import Section4Registration from "../components/termsSections/Section4Registration";
import Section5License from "../components/termsSections/Section5License";
import Section6Payment from "../components/termsSections/Section6Payment";
import Section7IPRights from "../components/termsSections/Section7IPRights";
import Section8Confidentiality from "../components/termsSections/Section8Confidentiality";
import Section9Warranties from "../components/termsSections/Section9Warranties";
import Section10Limitations from "../components/termsSections/Section10Limitations";
import Section11Indemnification from "../components/termsSections/Section11Indemnification";
import Section12Termination from "../components/termsSections/Section12Termination";
import Section13Governing from "../components/termsSections/Section13Governing";
import Section14Provisions from "../components/termsSections/Section14Provisions";
import Section15Prohibitions from "../components/termsSections/Section15Prohibitions";
import Section16YouTubeAPI from "../components/termsSections/Section16YouTubeAPI";

const TermsAndConditions = () => {
  // Scroll to top on component mount
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div>
      <Helmet>
        <title>Terms and Conditions | Comparedly</title>
        <meta name="description" content="Read the Terms and Conditions for using Comparedly. Understand your rights and responsibilities when using our social media benchmarking platform." />
        <meta property="og:title" content="Terms and Conditions | Comparedly" />
        <meta property="og:description" content="Read the Terms and Conditions for using Comparedly. Understand your rights and responsibilities when using our social media benchmarking platform." />
      </Helmet>
      <Navbar />
      <div className="terms-container">
        <h1>Terms and Conditions</h1>
        <p>Last updated: April 7, 2025</p>

        <Section1Introduction />
        <Section2Acceptance />
        <Section3Definition />
        <Section4Registration />
        <Section5License />
        <Section6Payment />
        <Section7IPRights />
        <Section8Confidentiality />
        <Section9Warranties />
        <Section10Limitations />
        <Section11Indemnification />
        <Section12Termination />
        <Section13Governing />
        <Section14Provisions />
        <Section15Prohibitions />
        <Section16YouTubeAPI />
        {/* Add more sections as needed */}
      </div>
      <Footer />
    </div>
  );
};

export default TermsAndConditions;
